const link = process.env.REACT_APP_SERVER_API_V2

const getNotesUrl = () => `${link}/notes`

export default getNotesUrl
